import { InitApp } from '../helpers/main'
import GlobalAppointmentOffcanvas from '../../../Modules/Appointment/Resources/assets/js/components/GlobalAppointmentOffcanvas.vue'

const app = InitApp()

app.component('global-appointment-offcanvas', GlobalAppointmentOffcanvas)

document.addEventListener('DOMContentLoaded', () => {
  const mountEl = document.querySelector('[data-render="global-booking"]')
  if (mountEl) {
    app.mount(mountEl)
  }
})

$(document).on('click', '#appointment-button', function () {
  const bookingForm = document.getElementById('appointment-form-offcanvas')
  const bsInstance = bootstrap.Offcanvas.getOrCreateInstance(bookingForm)
  bsInstance.hide()
  setTimeout(() => {
    bsInstance.show()
  }, 100)
})
